import mqtt, { MqttClient } from "mqtt";
import { store } from "../stateManager";
import { logger } from '../constant/winston';
import { MQTT_URL } from "../constant/common";
import { getRandomId } from "../utils/random-id";
import { assistantCompletion } from "../stateManager/store/tars";

let client: MqttClient | null = null

type TarsMessage = {
  type: 'code-completion',
  promptId: string,
  content: string
  seq: number
  finish_reason?: "stop"
}

export function connectToMQTT(userId: string) {
  const instanceName = getInstanceName()
  const topic = `a8studio/users/${userId}/tars-events`;
  const mqttUsername = `studioUser-${instanceName}-${userId}`;
  const mqttPassword = localStorage.getItem("studioToken") ?? ""

  // end the previously established mqtt connections
  if (client !== null) {
    client.end()
  }

  client = mqtt.connect(MQTT_URL, {
    keepalive: 30,
    clientId: getClientId(),
    username: mqttUsername,
    password: mqttPassword,
  });

  client.on("connect", () => {
    logger.info("mqtt client connected");
    client?.subscribe({ [topic]: { qos: 1 } }, () => {
      logger.info("subscribed to topic: ", topic)
    });
  });

  client.on("message", (topic: string, message: Buffer) => {
    const userId = getMQTTUserId()
    const state = store.getState();
    const lastPromptId = state.tars.lastPromptId

    if (topic === `a8studio/users/${userId}/tars-events`) {
      const tarsMessage: TarsMessage = JSON.parse(message.toString())
      const { type, promptId, finish_reason, content } = tarsMessage
      if (type === 'code-completion' && lastPromptId === promptId) {
        store.dispatch(assistantCompletion({
          isCompletionEnd: finish_reason === "stop",
          content,
        }))
      }
    }
  });

  client.on("disconnect", (event) => {
    logger.info("mqtt client disconnected: ", event)
  });

  client.on("reconnect", () => {
    logger.info("mqtt client trying to reconnect...");
  });

  client.on("error", (err) => {
    logger.error("mqtt client error occured: ", err);
  });
}

export function getMQTTUserId(): string {
  // NOTE: this is for handling hyphens in mqtt username
  return store.getState().user.data.user.id?.replaceAll("-", "");
}

function getClientId() {
  return 'studio-web-' + getRandomId()
}

function getInstanceName() {
  let instanceName = MQTT_URL.split("-")[1];

  if (instanceName === undefined) {
    return "prod"
  }

  if (instanceName.startsWith("staging") || instanceName.startsWith("testing")) {
    return instanceName.split(".")[0]
  }

  return instanceName
}

